import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { _DocumentFactory, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { _OrderToFinished } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { toast } from "react-toastify";
import { BasicTable, MASK_MONEY } from "../../../../theme/Component/BasicTable";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { Modal } from "../../../../theme/Component/Modal";
import { DocumentViewer } from "../../../../theme/Component/DocumentViewer";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
interface Props {
    idProductionOrder: any;
    productionOrderDate: any;
}

export const TraslateProdcutProccesFinished = ({ idProductionOrder, productionOrderDate }: Props) => {

    const OrderToFinished = useDataBean(_OrderToFinished);
    const single = Singleton.getInstance();
    const [docs, setDocs] = useState<any>([]);
    const _documentos = useDataBean(_DocumentFactory);
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modalverdoc, setModalverdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idProductionOrder, productionOrderDate])
    useEffect(() => {
        if (modalverdoc.view) {
            verDocumentos();
        }
    }, [modalverdoc.view]);
    const getLista = () => {

        OrderToFinished.instance.getProductionOrderToFinishedProductCatalog(idProductionOrder, productionOrderDate).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        OrderToFinished.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        OrderToFinished.deleteItemVoid(OrderToFinished.bean).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        OrderToFinished.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDProductionOrderToFinishedProduct', visible: true },
        { title: 'Producto', property: 'ProductName', visible: true },
        { title: 'Unidad de Medida', property: 'MeasurementUnitCode', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Valor Total', property: 'TotalValue', visible: true, mask: MASK_MONEY },
        { title: 'Almacén', property: 'StoreName', visible: true },
        { title: 'Lote', property: 'IDLot', visible: true },
        { title: 'Cuenta Contable Salida', property: 'AccountantIDName', visible: true },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Fecha Documento', property: 'DocumentDate', visible: true },
        { title: 'Estado', property: 'State', visible: true },
    ]
    const verDocumentos = () => {

        if (OrderToFinished.bean) {
            _documentos.instance.getPdfAccountantDocument(OrderToFinished.bean.IDDocument, null, OrderToFinished.bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                    setModalverdoc({ ...modalverdoc, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Documento', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalverdoc({ ...modalverdoc, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Traslados de Producto en Proceso a Producto Terminado">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={OrderToFinished.setBean} listButtons={listaBotones()} ></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={OrderToFinished.bean.Code} onChange={OrderToFinished.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={OrderToFinished.bean.Name} onChange={OrderToFinished.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalverdoc} updateModal={setModalverdoc}>
                        <div className="row">

                            <DocumentViewer
                                list={docs}
                                IDDocument={OrderToFinished.bean.IDDocument}
                                Since={OrderToFinished.bean.DocumentDate}
                            />
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {OrderToFinished.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}